import type { Database } from "../../../__definitions__/database-definitions";
import { SupabaseService } from "../../../server/supabase/base-supabase-service";

export type Folder = NonNullable<Database["public"]["Tables"]["folder"]["Row"]>;

export class SupabaseFolderService extends SupabaseService<"folder"> {
  table = "folder" as const;
}
